<script lang="ts" setup>
defineProps<{
  id: number
  avatar: string
  name: string
  badges?: number[]
  createdAt?: number
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xl2'
  auth?: User.Auth
  link?: boolean
  nameColor?: string
}>()
</script>

<template>
  <m-link
    :to="`/member/${id}`"
    :disabled="!link"
    :title="name"
    class="m-user-info"
    :class="size || 'md'"
  >
    <UserAvatar :user-id="id" :src="avatar" :size="size" :auth="auth" />
    <div
      class="m-user-info__user"
      :style="{
        display: size === 'xs' ? 'flex' : 'block'
      }"
    >
      <div
        class="m-user-info__name"
        :style="{
          color: nameColor
        }"
      >
        {{ name }}
        <m-badge v-if="size !== 'xs' && badges" :badges="badges.slice(0, 1)" />
      </div>
      <div class="m-user-info__info">
        <slot />
      </div>
    </div>
  </m-link>
</template>

<style lang="scss" scoped>
.m-user-info {
  display: flex;
  align-items: center;
  &__name {
    margin-left: 8px;
    color: var(--color-gray-900);
    display: flex;
  }
  &__info {
    margin-left: 8px;
    color: var(--color-gray-400);
  }
}
.m-user-info.lg {
  .m-user-info__user {
    margin-left: 12px;
  }
}
</style>
